export function ImgSelect({ size = 24 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Upper‑left corner curve */}
      <path
        d="M8.976 21C4.05476 21 3 19.9452 3 15.024"
        strokeWidth={2}
        strokeLinecap="round"
      />
      {/* Upper‑right corner curve */}
      <path
        d="M21 15.024C21 19.9452 19.9452 21 15.024 21"
        strokeWidth={2}
        strokeLinecap="round"
      />
      {/* Bottom‑right corner curve */}
      <path
        d="M15.024 3C19.9452 3 21 4.05476 21 8.976"
        strokeWidth={2}
        strokeLinecap="round"
      />
      {/* Bottom‑left corner curve */}
      <path
        d="M3 8.976C3 4.05476 4.05476 3 8.976 3"
        strokeWidth={2}
        strokeLinecap="round"
      />
      {/* Vertical line (center) */}
      <path
        d="M12 9.5L12 14.5"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Horizontal line (center) */}
      <path
        d="M14.5 12L9.5 12"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}